module.exports = __webpack_public_path__ + "img/babo-1.c62903aa.png";